export const FOOD = 'e018010a-ea04-11eb-bd21-704d7b683a73'
export const NON_FOOD = 'e0180109-ea04-11eb-bd21-704d7b683a73'
export const CAFE = 'e018010b-ea04-11eb-bd21-704d7b683a73'
